export default __webpack_public_path__ + "static/media/promo-1.18fbb438.png";